import React from "react";
import { Card, CardBody, Progress } from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
//react-redux comm
import { connect } from "react-redux";
import { store } from "../../_helpers";
import SearchPanel from "./pdm-panel";
import PaginatedResult from "./pdm-result";

// styling
import "./style.css";

import {
  commonActions,
  apiActions,
  modalActions,
  alertActions,
} from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import { commonService } from "../../_services";

const Categories = [
  { label: "Airline", value: "AirlineId" },
  { label: "Departure", value: "DepartureAirportId" },
  { label: "Destination", value: "DestinationAirportId" },
  { label: "Travel Route", value: "TravelRouteId" },
];
const TravelRouteId = [
  { label: "International", value: 0, cat: "TravelRouteId" },
  { label: "Domestic", value: 1, cat: "TravelRouteId" },
];

const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">PDM REPORT</h1>
      <p className="mb-0 subtitle text-nowrap">
        Post Departure Manifest Comparison Details
      </p>
    </header>
  </div>
);

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class PdmReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      catOptions: Categories,
      searchOptions: [],
      url: `${appConstants.PAS_URL}/api/postdeparturemanifest/searchpdmcomparison`,
      searchArray: false,
      searchLabelKey: "",
      searchValueKey: "",
      routeTypes: TravelRouteId,
      airlines: [],
      flights: [],
      desAirports: [],
      selectValue: {},
      depAirports: [],
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        dismissible: true,
      },
      pdmData: false,
      pageSize: 10,
      currentPage: 1,
      totalFlightCounts: 1,
      manifestInfo: false,
      contentErrorText: false,
      clickBD: false,
      manifestLink: "#",
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //    Fetch Airlines
    const reduxState = store.getState();
    if (reduxState.airlinesCarriers) {
      this.setState({
        airlines: this.formatAirlines(reduxState.airlinesCarriers.Results),
      });
    } else {
      this.fetchAirlines();
    }
    // Fetch Destination Airports
    if (reduxState.desAirports) {
      this.setState({
        desAirports: this.formatDestinationAirports(
          reduxState.desAirports.Results
        ),
      });
    } else {
      this.fetchDesAirports();
    }
    // Fetch Departure Airports
    if (reduxState.depAirports) {
      this.setState({
        depAirports: this.formatDepartureAirports(
          reduxState.depAirports.Results
        ),
      });
    } else {
      this.fetchDepAirports();
    }
    //Get today's manifests results
    // this.handleCatChange({ label: "Date Type", value: "DateType" });
  }

  componentDidUpdate(prevProps, prevState) {
    const { clickBD } = this.state;
    if (clickBD) {
      // debugger;
      this.search(1);
      this.setState({ clickBD: false });
    }
  }

  //update selected category
  updateCatValue = (newValue) => {
    this.setState({
      selectValue: newValue,
    });
    this.handleCatChange(newValue);
  };

  //populate the multi search options with appropriate category options
  handleCatChange = (option) => {
    if (option) {
      // incase all category options are remove
      switch (option.value) {
        case "AirlineId":
          return this.setState({
            searchOptions: this.state.airlines,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "DepartureAirportId":
          return this.setState({
            searchOptions: this.state.depAirports,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "DestinationAirportId":
          return this.setState({
            searchOptions: this.state.desAirports,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "TravelRouteId":
          return this.setState({
            searchOptions: this.state.routeTypes,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        default:
          return this.state;
      }
    }
    return this.setState({ searchOptions: [], searchArray: [] });
  };

  // remove option if option in that category is already selected
  switchOptionsPerCategory = (currentArray, newArray, category) => {
    const { selectValue } = this.state;
    let currentCat = category ? category : selectValue;

    let optionToReplace = currentArray.filter(
      (option) => option.cat === currentCat.value
    )[0];
    // console.log("optionToReplace: " + optionToReplace);

    if (optionToReplace) {
      return newArray.filter(
        (option) => option.label !== optionToReplace.label
      );
    } else {
      return newArray;
    }
  };

  //update selected options categories
  handleSelectChange = (newValue, category) => {
    let currentArray = this.state.searchArray;

    //debugger;
    let newArray =
      currentArray.length > 0
        ? this.switchOptionsPerCategory(
            this.state.searchArray,
            newValue,
            category
          )
        : newValue;
    this.setState({ searchArray: newArray });
  };

  fetchAirlines = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        this.setState({
          airlines: this.formatAirlines(airlinesCarriers.Results),
        });
        //this.formatAirlines(res.data.Results);
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        // console.log('Error', error);
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchDesAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDesAirports())
      .then(() => {
        const airports = this.props.desAirports;
        let desAirports = airports.Results;
        desAirports = this.formatDestinationAirports(desAirports);
        this.setState({
          desAirports,
        });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchDepAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDepAirports())
      .then(() => {
        const airports = this.props.depAirports;
        //
        let depAirports = airports.Results;
        depAirports = this.formatDepartureAirports(depAirports);
        this.setState({ depAirports });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  formatAirlines = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "AirlineId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  formatSearchParameters = (res) => {
    if (res.length > 0) {
      let searchParameters = {};
      res.map(
        (parameter) => (searchParameters[parameter.cat] = parameter.value)
      );
      return searchParameters;
    }
    return {};
  };

  formatDestinationAirports = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "DestinationAirportId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  formatDepartureAirports = (res) => {
    let data = [];
    for (let item of res) {
      item["cat"] = "DepartureAirportId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
  }

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  search = (pageNumber) => {
    const { dispatch } = this.props;
    const { searchArray, pageSize, startDate, endDate } = this.state;
    this.setState({ contentError: false });
    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      pageNumber = 1;
    } else {
      dispatch(apiActions.startRequest());
    }

    let fromPage = pageSize * (pageNumber - 1);

    let searchParams = this.formatSearchParameters(searchArray);

    let payload__ = {
      PageSize: pageSize,
      From: fromPage,
      Parameter: {
        DateType: 1,
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
        ...searchParams,
      },
    };

    let url = this.state.url;
    appHelpers
      .postRequest(url, payload__, {})
      .then((res) => {
        this.setState({
          pdmData: res.data.TotalCount > 0 ? res.data : false,
          currentPage: pageNumber,
        });

        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        //dispatch(alertActions.error(errorMessage));
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
        this.setState({ contentError: errorMessage });
      });
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  downloadExcel = () => {
    const { dispatch } = this.props;
    const { searchArray, startDate, endDate } = this.state;
    let searchParams = this.formatSearchParameters(searchArray);
    const payloadExcel = {
      PageSize: 100,
      From: 0,
      Parameter: {
        ...searchParams,
        DateType: 1,
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
      },
    };
    commonService.pdmDownloadExcel(payloadExcel).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        // let response = res.response.data.File;
        let response = res.response.data;
      

        const isBase64 = response.base64File ? true : false;
        const fileData = response.base64File || response; // filestream is in response directly
        // const mimeType = response.type || "application/pdf";
        // normalize mime type
        let mimeType = response.type || "application/pdf";
        if (mimeType === "application/xls") {
          mimeType = "application/vnd.ms-excel"; // correct for old .xls
        }
        appHelpers.downloadFileV2(
          fileData,
          "PDM_Report",
          isBase64,
          mimeType
        );
        // window.open(response, "_blank");
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });

    dispatch(apiActions.startRequest());
  };

  downloadPdf = () => {
    const { dispatch } = this.props;
    const { searchArray, startDate, endDate } = this.state;
    let searchParams = this.formatSearchParameters(searchArray);
    const payloadPdf = {
      PageSize: 100,
      From: 0,
      Parameter: {
        ...searchParams,
        DateType: 1,
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
      },
    };
    commonService.pdmDownloadPdf(payloadPdf).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        // let response = res.response.data.File;
        let response = res.response.data;
        const isBase64 = response.base64File ? true : false;
        const fileData = response.base64File || response;
        appHelpers.downloadFileV2(fileData, "PDM_Report", isBase64);
        // window.open(response, "_blank");
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });

    dispatch(apiActions.startRequest());
  };

  render() {
    const {
      contentErrorText,
      catOptions,
      selectValue,
      searchOptions,
      searchLabelKey,
      searchValueKey,
      searchArray,
      contentError,
      currentPage,
      pageSize,
      pdmData,
    } = this.state;
    const { requesting, pageRequesting } = this.props;

    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}

            {!contentError && !pageRequesting && (
              <CardBody>
                <h6 className="mb-4 text-uppercase">Search Panel</h6>
                <SearchPanel
                  contentErrorText={contentErrorText}
                  categories={catOptions}
                  selectedCat={selectValue}
                  multiOptions={searchOptions}
                  multiLabelKey={searchLabelKey}
                  multiValueKey={searchValueKey}
                  multiArray={searchArray}
                  onCatValueChange={this.updateCatValue}
                  onMultiValueChange={this.handleSelectChange}
                  onSearch={this.search}
                  startDateChange={(startDate) => this.setState({ startDate })}
                  endDateChange={(endDate) => this.setState({ endDate })}
                />

                <CardBody>
                  {!pageRequesting && pdmData && (
                    <div>
                      <PaginatedResult
                        downloadExcel={this.downloadExcel}
                        downloadPdf={this.downloadPdf}
                        pdmResults={pdmData}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={pdmData.TotalCount}
                      />
                    </div>
                  )}
                  {!pageRequesting && !pdmData && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    airlinesCarriers: state.airlinesCarriers,
    desAirports: state.desAirports,
    depAirports: state.depAirports,
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting,
    modal: state.modal,
  };
}

export default connect(mapStateToProps)(PdmReport);



// WEBPACK FOOTER //
// ./src/views/pdm-report/index.js